/* 🤖 this file was generated by svg-to-ts */
export const siriusChartBarVerticalDuotone: {
  name: 'chart_bar_vertical_duotone';
  data: string;
} = {
  name: 'chart_bar_vertical_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M19.875 3.75h-5.25V19.5h5.25V3.75Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.875 3.75a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 .75.75v15h.75a.75.75 0 0 1 0 1.5H2.625a.75.75 0 0 1 0-1.5h.75v-6a.75.75 0 0 1 .75-.75h4.5V8.25a.75.75 0 0 1 .75-.75h4.5V3.75Zm-5.25 9.75h-3.75v5.25h3.75V13.5Zm10.5-9v14.25h-3.75V4.5h3.75ZM13.875 9v9.75h-3.75V9h3.75Z" fill="currentColor"/></svg>`
};
